import { FormControl, Button, InputLabel } from '@mui/material';

import { useNonHookTrans } from '~/hooks/useTrans';
import TextFieldEnter from "~/mui/TextFieldEnter";
import { MySelect, MyMenuItem } from "~/mui/MySelect";
import { myUseState } from "~/hooks/myUseState";

interface IState<TFilter> {
	filterType: TFilter;
	filterValue: string;
	filterValueDisabled: boolean;
}

interface IFilter<TFilter> {
	type: TFilter;
	onFilter: (selType: TFilter, inputValue: string) => void;
	selectItems: Array<{ value: TFilter, text: string }>;
	selectTitle?: string;
	inputTitle?: string;
	btnTitle?: string;
	disabledTypes?: Array<TFilter>;
}

export default function Filter<TFilter>({
	type = "" as TFilter,
	selectTitle = "",
	inputTitle = "",
	btnTitle = useNonHookTrans().trans("filter"),
	disabledTypes = [],
	onFilter = () => {},
	selectItems = [],
}: IFilter<TFilter>) {
	const { state, setState } = myUseState<IState<TFilter>>({
		filterType: type,
		filterValue: "",
		filterValueDisabled: disabledTypes.indexOf(type) !== -1,
	});

	function updateFilter(value: TFilter) {
		const filterValueDisabled = disabledTypes.indexOf(value) !== -1;

		setState(prev => ({
			...prev,
			filterType: value,
			filterValue: filterValueDisabled ? "" : prev.filterValue,
			filterValueDisabled,
		}));
	}

	function sendFilter() {
		onFilter(state.filterType, state.filterValue);
	}

	return <>
		<FormControl size="small">
			<InputLabel>{ selectTitle }</InputLabel>
			<MySelect
				value={state.filterType}
				onChange={event => updateFilter(event.target.value as TFilter)}
				label={ selectTitle }
			>
				{ selectItems.map(item => <MyMenuItem value={item.value as string} key={item.value as string}>{ item.text }</MyMenuItem>) }
			</MySelect>
		</FormControl>
		<TextFieldEnter
			label={inputTitle}
			value={state.filterValue}
			onEnter={() => sendFilter()}
			onChange={event => setState(prev => ({ ...prev, filterValue: event.target.value }))}
			color="success"
			size="small"
			disabled={state.filterValueDisabled}
			sx={{ backgroundColor: "#fff" }}
		/>
		<Button color="success" variant="contained" onClick={sendFilter}>
			{ btnTitle }
		</Button>
	</>;
}
